import { Routes } from '@angular/router';
import { AdminGuard } from 'src/app/shared/guards/admin.guard';
import { AdminOrRapidocsGuard } from 'src/app/shared/guards/admin-or-rapidocs.guard';
import { RapidocsAdminGuard } from 'src/app/shared/guards/rapidocs-admin.guard';
import { OrderPage } from '../order/pages/main/order.page';

export const platformCoreRoutes: Routes = [
    { path: '', redirectTo: 'orders', pathMatch: 'full' },
    {
        path: 'orders',
        component: OrderPage,
    },
    {
        path: 'clients',
        loadChildren: () => import('../clients/clients.module').then(x => x.ClientsModule),
    },
    {
        path: 'templates',
        loadChildren: () => import('../templates/template.module').then(x => x.TemplatesModule),
    },
    {
        path: 'clients',
        loadChildren: () => import('../clients/clients.module').then(x => x.ClientsModule),
    },
    {
        path: 'members',
        loadChildren: () => import('../members/member.module').then(x => x.MembersModule),
        canActivate: [AdminGuard],
    },
    {
        // Configurações da empresa e do usuário na MESMA tela, em abas (o menu tem uma
        // entrada só). As telas antigas viraram rotas filhas daqui.
        path: 'settings',
        loadChildren: () => import('../settings/settings.routes').then(x => x.settingsRoutes),
    },
    // Endereços antigos: links e favoritos salvos continuam abrindo a aba certa.
    { path: 'company/settings', redirectTo: 'settings/company' },
    { path: 'user/settings', redirectTo: 'settings/user' },
    {
        // Convites recebidos pelo próprio usuário: sem guard, o convite é da PESSOA
        // (chega por e-mail/notificação) e não depende do perfil na empresa atual.
        path: 'invites',
        loadChildren: () => import('../invites/invite.module').then(x => x.InvitesModule),
    },
    {
        path: 'plans',
        loadChildren: () => import('../plans/plans.module').then(x => x.PlansModule),
    },
    {
        path: 'usage',
        loadChildren: () => import('../usage/usage.module').then(x => x.UsageModule),
    },
    {
        path: 'audit',
        loadComponent: () =>
            import('../rapidocs/pages/audit/audit-list.page').then(x => x.AuditListPage),
        canActivate: [AdminOrRapidocsGuard],
    },
    {
        // Campanhas de novidades por e-mail: staff RapiDocs, como o consumo de IA.
        path: 'release-notes',
        loadComponent: () =>
            import('../rapidocs/pages/release-notes/release-notes.page').then(
                x => x.ReleaseNotesPage
            ),
        canActivate: [RapidocsAdminGuard],
    },
    {
        // Esteira de deploys (app por enquanto): staff RapiDocs.
        path: 'deploys',
        loadComponent: () =>
            import('../rapidocs/pages/deploys/deploys.page').then(x => x.DeploysPage),
        canActivate: [RapidocsAdminGuard],
    },
    {
        path: 'deploys/connections',
        loadComponent: () =>
            import('../rapidocs/pages/deploys/connections/deploy-connections.page').then(
                x => x.DeployConnectionsPage
            ),
        canActivate: [RapidocsAdminGuard],
    },
    {
        path: 'ai-usage',
        loadChildren: () => import('../ai-usage/ai-usage.module').then(x => x.AiUsageModule),
        canActivate: [RapidocsAdminGuard],
    },
];
